import { Injectable, inject } from '@angular/core';

import { EpcotConfig, MyBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { MyBetsEventModel } from '../models/my-bets-event.model';

@Injectable({ providedIn: 'root' })
export class MyBetsUtilService {
    private isPrintView: boolean;
    private mybetsConfig = inject(MyBetsConfig);
    private epcotConfig = inject(EpcotConfig);

    setPrintState(isPrintView: boolean) {
        this.isPrintView = isPrintView;
    }

    isBetCardRedesigned(): boolean {
        return this.epcotConfig.isEnabled && this.mybetsConfig.enableRedesignedBetCard && !this.isPrintView;
    }

    isGridScoreboardEnabled(event: MyBetsEventModel | null): boolean {
        if (event == null) {
            return false;
        }
        if (!this.mybetsConfig.showGridScoreBoardConfig) {
            return false;
        }
        return !!(
            this.mybetsConfig.showGridScoreBoardConfig.sportIds?.some((key) => event.sport.id === key) ||
            this.mybetsConfig.showGridScoreBoardConfig.competitionIds?.some((key) => event.league.id === key)
        );
    }
}
